import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import routes from './routes';
import swal from 'sweetalert2';
import state from '@/state';

const APP_NAME = 'Abire Planeta vivo';

let appInitialized = false;
let appClientInitialized = false;
let appAdminInitialized = false;

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        return { top: 0 };
    }
});

router.beforeEach((to, from, next) => {
    if (to.path === '/' || to.name === 'home') {
        document.title = APP_NAME;
    } else if (to.name) {
        const routeName = to.name.charAt(0).toUpperCase() + to.name.slice(1);
        document.title = `${APP_NAME} | ${routeName}`;
    } else {
        document.title = APP_NAME;
    }

    next();
});

router.beforeEach(async (to, from, next) => {
    try {
        if (to.meta.requireAuth) {
            const userData = state.getters['users/get_user_data'];

            if (!userData.user_logged || !userData.access_token) {
                throw 'Para acessar esta funcionalidade, faça seu login na plataforma!';
            }

            // Só verifica no primeiro acesso da sessão (token pode estar stale do localStorage)
            if (!appInitialized) {
                try {
                    await axios.get(
                        `${process.env.VUE_APP_BACKEND_URL}/meta/verify_token/users`,
                        { headers: { Authorization: `Bearer ${userData.access_token}` } }
                    );
                    appInitialized = true;
                } catch (err) {
                    appInitialized = false;
                    state.dispatch('users/logout');

                    const status = err.response?.status;
                    const msg = status === 404
                        ? 'Sua conta não foi encontrada. Entre em contato com o suporte.'
                        : 'Sua sessão expirou. Por favor, faça login novamente.';

                    throw msg;
                }
            }
        }

        if (to.name === 'login') appInitialized = false;

        next();
    } catch (issue) {
        await swal.fire({
            title: 'Acesso Restrito',
            text: issue,
            icon: 'warning',
            confirmButtonText: 'Fazer Login',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
        });

        next({ name: 'login' });
    }
});

router.beforeEach(async (to, from, next) => {
    try {
        if (to.meta.requireClientAuth) {
            const clientData = state.getters['clients_users/get_client_data'];

            if (!clientData.user_logged || !clientData.access_token) {
                throw 'Para acessar esta área, faça seu login como cliente!';
            }

            if (!appClientInitialized) {
                try {
                    await axios.get(
                        `${process.env.VUE_APP_BACKEND_URL}/meta/verify_token/clients`,
                        { headers: { Authorization: `Bearer ${clientData.access_token}` } }
                    );
                    appClientInitialized = true;
                } catch (err) {
                    appClientInitialized = false;
                    state.dispatch('clients_users/logout');

                    const status = err.response?.status;
                    const msg = status === 404
                        ? 'Sua conta não foi encontrada. Entre em contato com o suporte.'
                        : 'Sua sessão expirou. Por favor, faça login novamente.';

                    throw msg;
                }
            }
        }

        if (to.name === 'clients_login') appClientInitialized = false;

        next();
    } catch (issue) {
        await swal.fire({
            title: 'Acesso Restrito',
            text: issue,
            icon: 'warning',
            confirmButtonText: 'Fazer Login',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
        });

        next({ name: 'clients_login' });
    }
});

router.beforeEach(async (to, from, next) => {
    try {
        if (to.meta.requireAdminAuth) {
            const adminData = state.getters['admins_users/get_admin_data'];

            if (!adminData.user_logged || !adminData.access_token) {
                throw 'Para acessar o painel administrativo, faça seu login!';
            }

            if (!appAdminInitialized) {
                try {
                    await axios.get(
                        `${process.env.VUE_APP_BACKEND_URL}/meta/verify_token/admins`,
                        { headers: { Authorization: `Bearer ${adminData.access_token}` } }
                    );
                    appAdminInitialized = true;
                } catch (err) {
                    appAdminInitialized = false;
                    state.dispatch('admins_users/logout');

                    const status = err.response?.status;
                    const msg = status === 404
                        ? 'Sua conta não foi encontrada. Entre em contato com o suporte.'
                        : 'Sua sessão expirou. Por favor, faça login novamente.';

                    throw msg;
                }
            }
        }

        if (to.name === 'admin_login') appAdminInitialized = false;

        next();
    } catch (issue) {
        await swal.fire({
            title: 'Acesso Restrito',
            text: issue,
            icon: 'warning',
            confirmButtonText: 'Fazer Login',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
        });

        next({ name: 'admin_login' });
    }
});

export default router;
